module.exports = __webpack_public_path__ + "img/img37.78f3b43a.jpg";